<template>
  <div>
    <div v-show='
      this.$store.state.product.Product.ProductCode==="CIBCAnnual18Day"||
      this.$store.state.product.Product.ProductCode==="CIBCAnnual8Day"||
      this.$store.state.product.Product.ProductCode==="CIBCIAnnual18Day"||
      this.$store.state.product.Product.ProductCode==="CIBCIAnnual8Day"'  class='form-row'>
      <div class='col-12' v-html="$t('text.page10_multitripwarning')"></div>
      <div class='col-12' style='margin-top:40px;'>
        <div class='row no-gutters'>
          <div class='col'>
            <label for='tripStart' style='margin-top:0px;'>{{$t('text.page10_input1')}}<span class='requiredText' aria-hidden='true'>*</span><br/>{{$t("text.dateofbirthformat")}}</label>
          </div>
          <div class='col-auto'>
            <button class="moreHelp" @click="openTooltip($t('text.page10_input1_tooltip'))" :aria-label="$t('text.moreinformation') + $t('text.page10_input1')" >
              <img src='../assets/images/helpIcon.png' style='margin-top:1px;' alt=""/>
            </button>
          </div>
        </div>
        <datepicker id='tripStart' 
          v-model='tripStart'
          :placeholder='$t("text.datePlaceholder")'
          input-class='form-control' 
          model-type="format"
           :day-class="() => ''"
          :locale="getLocale()"
          :format="'MM/dd/yyyy'"
          :disabled-dates="disabledTripDates"
          :typeable="true"
          :auto-apply="true"
          :enable-time-picker="false"
          :text-input="{
            format: ['MM/dd/yyyy'],
            tabSubmit: true,
            openMenu: true
          }"
          aria-required="true"></datepicker>
      </div>
    </div>
    <div class='form-row'>
      <div class='col-12'>
        <span for='tripStart' class='feedback' id='err_tripStart' tabindex='-1'></span>
      </div>
    </div>
    <div class='form-row'>
      <div class='col-12'>
        <input v-model="departureDate" id='departureDate' style='display:none;'>
      </div>
    </div> 

    <div class='form-row' style='margin-top:40px;'>
      <div class='col-12'>
        <p class='textApplicant'>{{$t('text.traveller')}} 1</p>
      </div>
    </div>

    <div class='form-row' >
      <div class='col-12 col-sm-6'>
        <label for='traveller1_firstname'>{{$t('text.firstname')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
        <input v-model='traveller1_firstname' aria-required="true" class='form-control' id='traveller1_firstname' :placeholder="$t('text.placeholderFirstName')" maxlength="50" aria-describedby='err_traveller1_firstname'/>
        <span for='traveller1_firstname' class='feedback' id='err_traveller1_firstname' tabindex='-1'></span>
      </div>
      <div class='col-12 col-sm-6'>
        <label for='traveller1_lastname'>{{$t('text.lastname')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
        <input v-model='traveller1_lastname' aria-required="true" class='form-control' id='traveller1_lastname' :placeholder="$t('text.placeholderLastName')" maxlength="50" aria-describedby='err_traveller1_lastname'/>
        <span for='traveller1_lastname' class='feedback' id='err_traveller1_lastname' tabindex='-1'></span>
      </div>
    </div>  

    <div class='form-row'>
      <div class='col-12'>
        <label for='traveller1_dob' v-html='$t("text.dateofbirth")'></label><br/>
        <input id='traveller1_dob' class='form-control' readonly='readonly'  v-model='traveller1_dob' aria-describedby='err_traveller1_dob'/>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-8'>
        <label for='address1'>{{$t('text.page10_input4')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
        <input v-model='address1' aria-required="true" class='form-control' id='address1' :placeholder="$t('text.page10_addressplaceholder')" aria-describedby='err_address1'/>
        <span for='address1' class='feedback' id='err_address1'></span>
      </div>
      <div class='col-4'>
        <label for='address2'>{{$t('text.page10_suite')}}</label><br/>
        <input v-model='address2' class='form-control' id='address2' aria-required="false" :placeholder="$t('text.page10_suiteplaceholder')"/>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-4'>
        <label for='city'>{{$t('text.page10_input5')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
        <input v-model='city' aria-required="true" class='form-control' id='city' :placeholder="$t('text.page10_input5')" aria-describedby='err_city'/>
        <span for='city' class='feedback' id='err_city' tabindex='-1'></span>
      </div>
      <div class='col-6 col-sm-4'>
        <label for='province'>{{$t('text.page10_input6')}}</label><br/>
        <select v-model='province' aria-required="true" class='form-control' id='province' :placeholder="$t('text.select')" aria-describedby='err_province' disabled="disabled">
          <option value="" disabled selected>{{$t("text.select")}}</option>
          <option :value='$t("text.prov1v")'>{{$t("text.prov1")}}</option>
          <option :value='$t("text.prov2v")'>{{$t("text.prov2")}}</option>
          <option :value='$t("text.prov3v")'>{{$t("text.prov3")}}</option>
          <option :value='$t("text.prov4v")'>{{$t("text.prov4")}}</option>
          <option :value='$t("text.prov5v")'>{{$t("text.prov5")}}</option>
          <option :value='$t("text.prov6v")'>{{$t("text.prov6")}}</option>
          <option :value='$t("text.prov7v")'>{{$t("text.prov7")}}</option>
          <option :value='$t("text.prov8v")'>{{$t("text.prov8")}}</option>
          <option v-if='!(this.$store.state.site!=="cibc"&&this.$i18n.locale==="fr")' :value='$t("text.prov9v")'>{{$t("text.prov9")}}</option>
          <option :value='$t("text.prov10v")'>{{$t("text.prov10")}}</option>
          <option v-if='!(this.$store.state.site!=="cibc"&&this.$i18n.locale==="en")' :value='$t("text.prov11v")'>{{$t("text.prov11")}}</option>
          <option :value='$t("text.prov12v")'>{{$t("text.prov12")}}</option>
          <option :value='$t("text.prov13v")'>{{$t("text.prov13")}}</option>
        </select>
        <span for='province' class='feedback' id='err_province' tabindex='-1'></span>
      </div>
      <div class='col-6 col-sm-4'>
        <label for='Postal code'>{{$t('text.page10_input7')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
        <input v-model='postalcode' aria-required="true" class='form-control' id='postalcode' :placeholder="$t('text.page10_input7')" maxlength='7' aria-describedby='err_postalcode'/>
        <span for='postalcode' class='feedback' id='err_postalcode' tabindex='-1'></span>
      </div>
    </div>

    <div class='form-row'>
      <div class='col-12 col-sm-6 order-sm-1'>
        <label for='phone'>{{$t('text.page10_input8')}} <span class='requiredText' aria-hidden='true'>*</span></label><br/>
      </div>
      <div class='col-12 col-sm-6 order-sm-3'>
        <input v-model='phone' aria-required="true" class='form-control' id='phone' name='phone' placeholder="" maxlength="15" aria-describedby='err_phone'/>
      </div>
      <div class='col-12 col-sm-6 order-sm-5'>
          <span for='phone' class='feedback' id='err_phone' tabindex="-1"></span>
      </div>
      <div class='col-12 col-sm-6 order-sm-2'>
        <label for='Email'>{{$t('text.page10_input9')}}</label><br/>
      </div>
      <div class='col-12 col-sm-6 order-sm-4'>
        <input v-model='email' aria-required="false" class='form-control' name='email' id='email' :placeholder="$t('text.email')" maxlength='254' aria-describedby='err_email'/>
      </div>
      <div class='col-12 col-sm-6 order-sm-6'>
          <span for='email' class='feedback' id='err_email' tabindex='-1'></span>
      </div>
    </div>
    <div class='form-row' style='border: 1px solid #ccc; background-color: #FFFFFF; margin-top:40px;padding:20px;padding-left:5px;'>
      <div class='col-auto text-center'>
        <b style='padding-left:15px; padding-right:15px;'>{{$t('text.optional')}}</b><br/><br/>
        <input v-model="confirmCASL" class='regular-checkbox' type='checkbox' id='confirmCASL' name="confirmCASL" :aria-checked='confirmCASL' role='checkbox'>
      </div>
      <div class='col'>
        <label for='confirmCASL' class='checkbox-label' v-html="$t('text.page10_CASL')"></label>
        <!-- <label v-if='this.$store.state.site==="cibc"' for='confirmCASL' class='checkbox-label' v-html="$t('text.page10_CASL')"></label> -->
        <!-- <label v-else for='confirmCASL' class='checkbox-label' v-html="$t('text.page10_CASLnm')"></label> -->
      </div>
    </div>
    <div class ='form-row' style='margin-top:20px; background-color: #EEEEEE; padding:20px; display:none;'>
      <fieldset role="group" class='form-group' style='margin-top:0px;'>
          <legend v-if="this.$store.state.site==='cibc'" id='lbl_fulfillment' class='radioLegend' style='font-weight: 600; color: #333;'>{{$t("text.page10_communicationmethod")}}</legend>
          <legend v-else id='lbl_fulfillment' class='radioLegend' style='font-weight: 600; color: #333;'>{{$t("text.page10_communicationmethodnm")}}</legend>
          <div class='col' style='padding-top:15px;padding-left:0px;padding-right:0px;'>
              <span class='radio'>
                  <input v-model="fulfillment" name='fulfillment' id='cm1' type='radio' value='email' checked='checked' aria-labelledby='lbl_fulfillment_email'/>
                  <label id='lbl_fulfillment_email' for='cm1' class='radio-label'>{{$t('text.email')}}</label>
              </span>
              <span class='radio'>
                  <input v-model="fulfillment" name='fulfillment' id='cm2' type='radio' value='mail' aria-labelledby='lbl_fulfillment_mail'/>
                  <label id='lbl_fulfillment_mail' for='cm2' class='radio-label'>{{$t('text.mail')}}</label>
              </span>
              <span class='radio'>
                  <input v-model="fulfillment" name='fulfillment' id='cm3' type='radio' value='both' aria-labelledby='lbl_fulfillment_both'/>
                  <label id='lbl_fulfillment_both' for='cm3' class='radio-label'>{{$t('text.both')}}</label>
              </span>
          </div>
      </fieldset>
    </div>
    <div id='reFocusBlock' tabindex='-1'>
    </div>
  </div>
</template>

<script>
import getLocale from "../utils/getLocale";
import { addNavProceedCheck } from "../utils/navProceed.js";
import { validationRules } from "../utils/validation_rules.js";
import { validateForm, validateField, callValidationStatusOnBlur } from "../utils/validation.js";
import { validateCoverageStartDate, validateEmail } from "../utils/validation_custom.js";
import bus from "../utils/bus.js";

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
const tripStartMinDate = new Date();
tripStartMinDate.setHours(0, 0, 0, 0);
const tripStartMaxDate = new Date(tripStartMinDate);
tripStartMaxDate.setDate(tripStartMaxDate.getDate() + 30);

export default {
  components: {
    Datepicker: VueDatePicker
  },
  data() {
    return {
      disabledTripDates: (candidateDate) => {
        if (!candidateDate) {
          return false;
        }
        const normalizedDate = new Date(candidateDate);
        normalizedDate.setHours(0, 0, 0, 0);
        return normalizedDate < tripStartMinDate || normalizedDate >= tripStartMaxDate;
      },
      province_full: this.$store.state.province_full,
    }
  },
  computed: {
    departureDate: {
      get() {
        return this.$store.state.departureDate;
      }
    },
    tripStart: {
      get() {
        return this.$store.state.tripStart;
      },
      set(newValue) {
        validateField(document.getElementById("tripStart"), newValue, validationRules());

        document.getElementById("tripStart").classList.add("is-valid");
        document.getElementById("tripStart").classList.remove("is-invalid");
        if (validateField(document.getElementById("tripStart"), newValue, validationRules())) {
          validateCoverageStartDate(new Date(newValue));
        }
      }
    },
    traveller1_firstname: {
      get() {
        return this.$store.state.traveller1_firstname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller1_firstname"), newValue, validationRules());
      }
    },
    traveller1_lastname: {
      get() {
        return this.$store.state.traveller1_lastname;
      },
      set(newValue) {
        validateField(document.getElementById("traveller1_lastname"), newValue, validationRules());
      }
    },
    traveller1_dob: {
      get() {
        return this.$store.state.traveller1_dob;
      },
      set(newValue) {
        validateField(document.getElementById("traveller1_dob"), newValue, validationRules());
      }
    },
    address1: {
      get() {
        return this.$store.state.address1;
      },
      set(newValue) {
        validateField(document.getElementById("address1"), newValue, validationRules());
        if (document.getElementById("address1").classList.contains("is-invalid")) {
          document.getElementById("address2").classList.add("is-invalid");  
          document.getElementById("address2").classList.add("is-invalid");
          document.getElementById("address2").classList.remove("is-valid");
        } else if (document.getElementById("address1").classList.contains("is-valid")) {
          document.getElementById("address2").classList.remove("is-invalid");
          document.getElementById("address2").classList.add("is-valid");
        }
      }
    },
    address2: {
      get() {
        return this.$store.state.address2;
      },
      set(newValue) {
      }
    },
    city: {
      get() {
        return this.$store.state.city;
      },
      set(newValue) {
        validateField(document.getElementById("city"), newValue, validationRules());
      }
    },
    postalcode: {
      get() {
        return this.$store.state.postalcode;
      },
      set(newValue) {
          validateField(document.getElementById("postalcode"), newValue, validationRules());
      }
    },
    phone: {
      get() {
        return this.$store.state.phone;
      },
      set(newValue) {
        validateField(document.getElementById("phone"), newValue, validationRules());
      }
    },
    province: {
      get() {
        return this.$store.state.province;
      },
      set(newValue) {
        if(validateField(document.getElementById("province"), newValue, validationRules())){
          if(document.getElementById("postalcode").value!==""){
            document.getElementById("postalcode").classList.add("is-valid");
            validateField(document.getElementById("postalcode"), document.getElementById("postalcode").value,validationRules());
          }
        }
      }
    },
    email: {
      get() {
        return this.$store.state.email;
      },
      set(newValue) {
        validateEmail(newValue);
      }
    },
    confirmCoverage: {
      get() {
        return this.$store.state.confirmCoverage;
      },
      set() {
        validateField(document.getElementById("cc1y"), true, validationRules());
      }
    },
    confirmCASL: {
      get() {
        return this.$store.state.confirmCASL;
      },
      set() {
        validateField(
          document.getElementById("confirmCASL"),
          true,
          validationRules
        );
      }
    },
    fulfillment: {
      get() {
        return this.$store.state.fulfillment;
      },
      set() {
    
      }
    }
  },
  methods: {
    getLocale,
    datePickerLanguageLookup() {
        const locale = getLocale();
        if(locale==="fr") {
          return "fr";
        }
        else {
          return "en-US";
        }
    },
    
    openTooltip(text) {
      document.getElementById("keywordBody").innerHTML=text;
      this.$nextTick(()=>{
        document.getElementById("keywordBody").focus();
      });
      bus.$emit("openModal");
    }
  },
  mounted() {
    // FIREFOX BUG FIX - Set listener on checkbox to toggle Aria-Label
    
    if(navigator.userAgent.toLowerCase().indexOf("firefox") > -1){
      document.getElementById("confirmCASL").classList.remove("regular-checkbox");
    }

    // If this session already has a policy number, reset the session
    if(this.$store.state.policyNumber!==""){location.reload();}
    
    // Focus stepTitle for accessibility.
    this.$nextTick( () => {
      document.getElementById("stepTitle").focus();
    });

    // Ensure custom validaton runs when page opens.
    const tripStartValue = this.tripStart;
      if(tripStartValue){
        validateCoverageStartDate(
          new Date(tripStartValue),
          new Date(document.getElementById("departureDate").value)
        );
      }
  

    // Manually add ARIA tags for date time inputs
    document.getElementById("tripStart").setAttribute("aria-required","true");
    document.getElementById("tripStart").setAttribute("aria-describedby","err_tripStart");

    // Have fields begin validation on Blur, instead of when navigating to next page.
    callValidationStatusOnBlur(validationRules());
    const emailInput = document.getElementById("email");
    if (emailInput) {
      emailInput.addEventListener("blur", (e) => {
        e.target.classList.remove("is-invalid");
        e.target.classList.add("is-valid");
        validateEmail();
      });
    }
    validateEmail();

    // Check if Next button should be enabled or disabled.
    const targets = [
      document.getElementById("tripStart"),
      document.getElementById("traveller1_firstname"),
      document.getElementById("traveller1_lastname"),
      document.getElementById("traveller1_dob"),
      document.getElementById("address1"),
      document.getElementById("city"),
      document.getElementById("province"),
      document.getElementById("postalcode"),
      document.getElementById("phone")
    ];
    this.$nextTick( () => {
      addNavProceedCheck(targets);
    });
  },
}
</script>

<style>
.radioLegend {
  font-size: 16px;
}
</style>
